import _IconDown from "@arco-design/iconbox-react-m4b-next/esm/IconDown";
import React from 'react';
import Button from '@m4b-design/button';
import { useConfigContext } from '@m4b-design/config-provider';
var expandNodesStyle = {
  textAlign: 'center',
  margin: '5px 0 0 -15px',
  cursor: 'pointer'
};
export var MoreIcon = function MoreIcon(_a) {
  var onClick = _a.onClick;
  var globalPrefixCls = useConfigContext().prefixCls;
  var prefixCls = "".concat(globalPrefixCls, "-notice");
  return /*#__PURE__*/React.createElement("div", {
    style: expandNodesStyle,
    className: "".concat(prefixCls, "-icon-wrapper"),
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Button, {
    type: "text",
    size: "mini"
  }, "View More", /*#__PURE__*/React.createElement(_IconDown, null)));
};